import { errorToast } from "@/ui/toast/Toast";
import { createSubscriptionOrder } from "../api";
import { useApiSend } from "@/hooks/useApi";

export function useSubscribe() {
	const { mutateAsync, isPending, isError, error } = useApiSend({
		fn: createSubscriptionOrder,
	});

	const subscribe = async function (plan = "monthly") {
		const data = await mutateAsync(plan);

		if (data?.form_action && data?.form_data) {
			// Create a form dynamically and submit it to Monri
			const form = document.createElement("form");
			form.method = "POST";
			form.action = data.form_action;

			// Add all form data fields
			Object.entries(data.form_data).forEach(([key, value]) => {
				const input = document.createElement("input");
				input.type = "hidden";
				input.name = key;
				input.value = value;
				form.appendChild(input);
			});

			// Append to body, submit, then remove
			document.body.appendChild(form);
			form.submit();
		} else {
			console.log(data);
			errorToast(
				"Desila se greška pri pravljenju linka za pretplatu. Pokušajte opet."
			);
		}
	};

	return { subscribe, isPending, error, isError };
}
